export const insuranceTypes = ["EHC", "LTD", "MVA", "OHIP", "STD", "VET", "WSIB"]